import { type ReactElement } from "react";

import { Tooltip } from "#components/Tooltip";
import { AwsLogo, AwsWhiteLogo, AzureLogo, GcpLogo, TencentCloudLogo } from "#icons";

import type { CloudProvider } from "./formatProvider";
import type { ButtonProps } from "react-aria-components";

interface Props {
  provider: CloudProvider;
  invert?: boolean;
}

function renderProviderLogo(provider: CloudProvider, invert: boolean): ReactElement {
  const logoProps = { width: 22 };

  switch (provider) {
    case "AWS":
      return invert ? <AwsWhiteLogo {...logoProps} /> : <AwsLogo {...logoProps} />;

    case "Azure":
      return <AzureLogo {...logoProps} />;

    case "GCP":
      return <GcpLogo {...logoProps} />;

    case "TencentCloud":
      return <TencentCloudLogo {...logoProps} />;

    case "Kubernetes":
      // Use AwsLogo as a fallback for Kubernetes until it's added to @stacklet/ui
      return <AwsLogo {...logoProps} />;

    default:
      return <AwsLogo {...logoProps} />;
  }
}

export function ProviderIcon({ provider = "AWS", invert = false }: Props) {
  return (
    <div className="flex w-[1.5rem] items-center justify-center text-text-primary">
      <Tooltip
        buttonProps={
          {
            "aria-label": provider,
            "data-testid": "provider-tooltip",
          } as ButtonProps
        }
        title={provider}
      >
        <span>{renderProviderLogo(provider, invert)}</span>
      </Tooltip>
    </div>
  );
}
